import { render, staticRenderFns } from "./AbilityCompare.vue?vue&type=template&id=4ef346f8&scoped=true&"
import script from "./AbilityCompare.vue?vue&type=script&lang=js&"
export * from "./AbilityCompare.vue?vue&type=script&lang=js&"
import style0 from "./AbilityCompare.vue?vue&type=style&index=0&id=4ef346f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef346f8",
  null
  
)

export default component.exports